export default "__VITE_ASSET__$h682fJ3__"